module.exports = __webpack_public_path__ + "static/media/ashfaque.b4472c1a.jpg";